import {
    TRADELINK_SET_CONFIG,
    TRADELINK_FAILED_CONFIG_LOAD,
    TRADELINK_SET_ORDERS,
    TRADELINK_FAILED_ORDERS_LOAD,
    TRADELINK_SET_JOB,
    TRADELINK_FAILED_JOB_LOAD,
  } from "../types";
  
  const initialState = {
    config: {
      data: {
        syncEnabled: false,
        tradeLinkOneUserid: "",
        tradeLinkOneApiKey: "",
      },
      loading: false,
      error: null,
    },
    orders: {
      data: {
        content: [],
        totalPages: 0,
        totalElements: 0,
      },
      loading: false,
      error: null,
    },
    job: {
      data: {},
      loading: false,
      error: null,
    },
  };
  
  function tradelinkReducer(state = initialState, action = {}) {
    switch (action.type) {
      case TRADELINK_SET_CONFIG:
        return {
          ...state,
          config: {
            data: action.config,
            loading: false,
            error: null,
          },
        };
  
      case TRADELINK_FAILED_CONFIG_LOAD:
        return {
          ...state,
          config: {
            ...state.config,
            loading: false,
            error: action.error,
          },
        };
  
      case TRADELINK_SET_ORDERS:
        return {
          ...state,
          orders: {
            data: action.orders,
            loading: false,
            error: null,
          },
        };
  
      case TRADELINK_FAILED_ORDERS_LOAD:
        return {
          ...state,
          orders: {
            ...state.orders,
            loading: false,
            error: action.error,
          },
        };
  
      case TRADELINK_SET_JOB:
        return {
          ...state,
          job: {
            data: action.job,
            loading: false,
            error: null,
          },
        };
  
      case TRADELINK_FAILED_JOB_LOAD:
        return {
          ...state,
          job: {
            ...state.job,
            loading: false,
            error: action.error,
          },
        };
  
      default:
        return state;
    }
  }
  
  export default tradelinkReducer; 